import Footer from "../../newinterface/footer";
import Header from "../../newinterface/header";
import Spinner from "../../../common/spinner";
import OwlCarousel from "react-owl-carousel";
import Cities from ".././json/cities.json";
import { Progress, Spin, Select } from "antd";
import RequestCallback from ".././requestCallback";
import FullPopup from ".././fullPopup";
import Loader from ".././guestPortal/loader";
// import TravelModel from './model/travelModel';
import TravelModel from "./travelModel";
import DatePicker from "react-datepicker";
import moment from "moment";
import travelBookingApiService from "../../../../services/travelBookingApiService";
import i from "typed.js";
import { calculateBookingPrices } from "./bookingCalculations";
const { Option } = Select;
class NewLocations extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      communityData: [],
      startLimit: 0,
      loadMoreButton: false,
      communityName: "",
      selectedaddress: "",
      selectedAmenties: "",
      selectedcity: "",
      filterData: "",
      spinLoader: false,
      map: "",
      activeNumber: -1,
      amenitiesList: [],
      amenitiesId: [],
      address: "",
      cityId: "",
      communityName: "",
      companyname: "",
      countryId: "",
      latitude: "",
      longitude: "",
      startLimit: 0,
      stateId: "",
      userid: "",
      // loadingStatus: false,
      imgloader: true,
      communityImages: [],
      addresstext: false,
      communitytext: false,
      cities: Cities,
      selectedAmentiesData: [],
      selectedcommunityName: null,
      fullpopdata: {},
      allcitisdata: [],

      checkin: "07/10/2025",
      checkout: "11/30/2025",
      loadingStatus: false,
      communities: [],
      addressLat: 37.3209401,
      addressLng: -122.0240663,
      mapLoader: false,
      moveIn: null,
      moveOut: null,
      size: "",
      loadingPage: false,
    };
    this.TravelModel = new TravelModel(this, {});
    this.savedSearch = this.savedSearch.bind(this);
    this.Search = this.Search.bind(this);
    this.onClickCity = this.onClickCity.bind(this);
    this.handleDropDownSelect = this.handleDropDownSelect.bind(this);
  }

  async componentDidMount() {
    // const incomingState = this.props.location.state;
    // console.log(incomingState, "incomingState");
    // if (incomingState) {
    //   this.setState(
    //     {
    //       loadingPage: true,
    //       latitude: incomingState.latitude,
    //       longitude: incomingState.longitude,
    //       addressLat: incomingState.latitude,
    //       addressLng: incomingState.longitude,
    //       address: incomingState.address,
    //       checkin: moment(incomingState.checkin).format("MM/DD/YYYY"),
    //       checkout: moment(incomingState.checkout).format("MM/DD/YYYY"),
    //       moveIn: incomingState.checkin,
    //       moveOut: incomingState.checkout,
    //     },
    //     () => {
    //       this.Search(); // 👈 call after state is set
    //     }
    //   );
    // } else {
    await this.TravelModel.emptymap();
    this.setState({
      loadingPage: false,
    });
    // }

    // await this.TravelModel.getCommunities();
  }

  async componentDidUpdate() {
    // if (this.state.addressLat != 37.7749295 && this.state.addressLng != -122.4194155) {
    //     console.log('updateddd', this.state.addressLat, this.state.addressLng)
    //     // await this.TravelModel.getCommunities()
    // }
  }
  /* search functionality starting*/
  async setLocationAddress(e) {
    const inputValue = e.target.value.trim();
    e.preventDefault();
    const _this = this;
    await this.setState({ address: e.target.value, addresstext: true });

    if (inputValue.length < 2) {
      if (this.autocompleteInstance) {
        google.maps.event.clearInstanceListeners(
          document.getElementById("city-input1")
        );
        this.autocompleteInstance.unbindAll();
        google.maps.event.clearInstanceListeners(this.autocompleteInstance);
        this.autocompleteInstance = null;

        // Remove the pac-container (suggestion box)
        const pacContainers = document.getElementsByClassName("pac-container");
        Array.from(pacContainers).forEach((container) => {
          container.remove();
        });
      }
      return;
    }
    // await this.handleFocus();

    if (!this.autocompleteInstance && inputValue.length >= 2) {
      const icon =
        "https://s3-us-west-1.amazonaws.com/suiteam-website/Destination-Services/SuiteAme" +
        "rica-Destination-Services-Icon-Map-Marker-Green.png";
      this.autocompleteInstance = new google.maps.places.Autocomplete(
        document.getElementById("city-input1")
      );
      google.maps.event.addListener(
        this.autocompleteInstance,
        "place_changed",
        () => {
          var place = this.autocompleteInstance.getPlace();
          var placeDetails = {
            locality: "long_name",
            administrative_area_level_1: "short_name",
            country: "long_name",
          };
          place.address_components.forEach((i) => {
            var addressType = i.types[0];
            if (placeDetails[addressType]) {
              var val = i[placeDetails[addressType]];
              placeDetails[addressType] = val;
            }
          });
          let relocatedAddress = place.formatted_address;
          const newLat = place.geometry.location.lat();
          const newLng = place.geometry.location.lng();
          _this.setState({
            latitude: newLat,
            longitude: newLng,
            address: relocatedAddress,
            addressLat: newLat,
            addressLng: newLng,
          });
        }
      );
    }
  }

  countDaysBetween(checkInDate, checkOutDate) {
    var date1 = new Date(checkInDate);
    var date2 = new Date(checkOutDate);
    var timeDiff = Math.abs(date2.getTime() - date1.getTime());
    let diffDate = Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1;

    return diffDate;
  }

  async Search() {
    this.setState({
      loadingStatus: true,
    });
    let error = 0;
    const { moveIn, moveOut } = this.state;
    let checkInDate = moment(this.state.moveIn, "MM/DD/YYYY"),
      checkOutDate = moment(this.state.moveOut, "MM/DD/YYYY");
    if (!this.state.latitude && !this.state.longitude) {
      $("#city-input1").addClass("validation");
      error++;
      this.setState({
        loadingStatus: false,
      });
    } else {
      $("#city-input1").removeClass("validation");
    }
    if (this.state.moveIn == null) {
      $("#moveIn").addClass("validation");
      error++;
      this.setState({
        loadingStatus: false,
      });
    } else {
      $("#moveIn").removeClass("validation");
    }
    if (this.state.moveOut == null) {
      $("#moveOut").addClass("validation");
      error++;
      this.setState({
        loadingStatus: false,
      });
    } else {
      $("#moveOut").removeClass("validation");
    }

    if (moveIn && moveOut) {
      const daysDifference = moment(moveOut).diff(moment(moveIn), "days") + 1;

      console.log(daysDifference, "daysDifference===");
      if (daysDifference < 30) {
        $("#moveOut").addClass("validation");
        this.setState({
          loadingStatus: false,
        });
        error++;
      } else {
        $("#moveOut").removeClass("validation");
      }
    }

    try {
      if (error == 0) {
        let reqObj = {
          checkin: moment(this.state.moveIn).format("MM/DD/YYYY"),
          checkout: moment(this.state.moveOut).format("MM/DD/YYYY"),
          roomsize: this.state.size,
          latitude: this.state.latitude,
          longitude: this.state.longitude,
          complexamenities: [],
          allowpets: false,
          confirmedMoveOut: false,
          masterid: "",
          program: ["SA Web"],
          radius: 30,
          record_limit: 0,
          reqDays: 0,
          unitamenities: [],
        };
        // console.log(reqObj, "reqObj");
        let response = await travelBookingApiService.GetAvailableMastersInfo(
          reqObj
        );

        // console.log(response.message, "response");
        if (response.error == 0) {
          const { checkin, checkout } = this.state;
          const communitiesWithDailyRent = await Promise.all(
            response.message.map(async (row) => {
              const monthlyRent = row.mrent;
              const stayDays =
                moment(checkout).diff(moment(checkin), "days") + 1;
              const stayMonths = stayDays / 30;

              const lostRent = await this.lostRentCalculation(row);
              const lostRentPerMonth = lostRent / stayMonths;
              const newMonthlyRent = monthlyRent + lostRentPerMonth;

              // Optionally pass newMonthlyRent to the pricing function
              const { totalAmount } = await calculateBookingPrices(
                row.suite,
                newMonthlyRent
              );

              const dailyRent = totalAmount / 30;

              return {
                ...row,
                dailyRent,
              };
            })
          );
          // console.log(communitiesWithDailyRent, "communitiesWithDailyRent");

          this.setState({
            communities: communitiesWithDailyRent,
            loadingStatus: false,
            loadingPage: false,
          });
          await this.TravelModel.mapmethod();
        } else {
          this.setState({
            loadingStatus: false,
            loadingPage: false,
          });
          console.log(response.error, "error");
        }
      } else {
        this.setState({
          communities: [],
          loadingStatus: false,
          loadingPage: false,
        });
        // await this.TravelModel.mapmethod();
        await this.TravelModel.emptymap();
      }
    } catch (error) {
      this.setState({
        loadingStatus: false,
      });
      console.log(error, "error");
    }
  }

  async setValue(e) {
    var object = {};
    object[e.target.name] = e.target.value;
    this.setState(object);
    if (e.target.name == "countryId") {
      this.stateList(e.target.value);
    }
    if (e.target.name == "stateId") {
      this.cityList(e.target.value);
    }
    this.setState({
      communitytext: true,
    });
  }

  /* search functionality ending*/
  /*map method starting */

  async handleloadmore() {
    await this.setState({
      loadMoreButton: true,
      startLimit: this.state.startLimit + 10,
    });
    const limitData = {
      startLimit: this.state.startLimit,
      companyname: "suiteamerica",
      latitude: "",
      longitude: "",
      address: "",
      state_id: "",
      city_id: "",
      amenitiesId: "",
      communityName: "",
      countryId: "",
      userid: "",
      cities: [],
    };
    await this.mapmethod(limitData, "more");
    var element = document.getElementById("loadmoredown");
    element.scrollTop = element.scrollHeight;
  }
  async setValueAmenities(event) {
    this.setState({ selectedAmenties: event.target.value });
  }

  async savedSearch(
    savedSearchData,
    communityData,
    searchLatitude,
    searchLongitude
  ) {
    await this.setState({
      savedSearchData,
      communityData,
      searchLatitude,
      searchLongitude,
      default: 0,
      spinLoader: false,
    });
    const limitData = {
      startLimit: 0,
      companyname: "suiteamerica",
      latitude: "",
      longitude: "",
      address: this.state.address,
      state_id: "",
      city_id: "",
      amenitiesId: "",
      communityName: "",
      countryId: "",
      userid: "",
      cities: [],
    };
    await this.mapmethod(savedSearchData, "search");
  }

  async handleSearch() {
    let filterData = this.state.communityData.filter(
      (obj) =>
        obj.city_name.toLowerCase() == this.state.selectedcity.toLowerCase() ||
        obj.community_name == this.state.communityName.trim()
    );
    await this.setState({
      filterData: filterData,
    });
  }

  /* map functionality ending*/
  async handleOpenCarousel(row) {
    //console.log("for images", row.interiorimages);
    let communityImages =
      row.interiorimages != null && row.interiorimages != undefined
        ? row.interiorimages.split(",")
        : [];
    if (row.CommunityImages != null && row.CommunityImages != undefined) {
      communityImages.unshift({ image_name: row.image_name });
    }
    //console.log("for images", communityImages);
    if (communityImages.length) {
      let popUPimages = [];
      communityImages.forEach((element) => {
        popUPimages.push({
          image_name: element,
        });
      });

      row.CommunityImages = JSON.stringify(popUPimages);
      await this.setState({
        fullpopdata: row,
        communityImages: communityImages,
        imgloader: false,
      });
      setTimeout(
        function () {
          $("#fullmodel-Carousel1").modal("show");
        }.bind(this),
        500
      );
    }
  }
  async handleclose() {
    $("document").ready(function () {
      $("#smallmodel-Carousel1").modal("hide");
    });
  }
  async handleFocus() {
    if (this.state.address == "") {
      $("#showpopup").addClass("popover__wrapper");
    } else {
      let addres = this.state.address;
      let arr = this.state.allcitisdata;
      let obj = arr.find((o) => o.city == addres);
      let keyslenth = obj != undefined ? Object.keys(obj).length : {};
      if (keyslenth > 0) {
        $("#showpopup").addClass("popover__wrapper");
      } else {
        $("#showpopup").removeClass("popover__wrapper");
      }
    }
    await $("#city-input1").popover({
      html: true,
      content: function () {
        return $("#popp").html();
      },
    });
  }

  async handleRemovePop() {
    await $("#city-input1").popover("hide");
  }

  async _handleKeyDown1(e) {
    await $("#city-input1").popover("hide");
  }

  async onClickCity(data) {
    await this.setState({ address: data.city, latitude: "", longitude: "" });
    if (this.state.address == "Bay Area") {
      this.setState({ latitude: 37.8271784, longitude: -122.2913078 });
    }
    if (this.state.address == "New York City") {
      this.setState({ latitude: 40.7127753, longitude: -74.0059728 });
    }
  }
  async lostRentCalculation(row) {
    const availabilityStart = moment(row.availabilityStartDate);
    const checkinDate = moment(this.state.checkin);
    const daysDifference = checkinDate.diff(availabilityStart, "days");
    console.log(daysDifference, "daysDifference");

    if (daysDifference > 0) {
      const dailyrent = row.mrent / 30;
      return daysDifference * dailyrent;
    }

    return 0;
  }
  async calculateMonthlyRent(row) {
    const { checkin, checkout } = this.state;
    const monthlyRent = row.mrent;
    const dailyrent = monthlyRent / 30;
    const stayDays = moment(checkout).diff(moment(checkin), "days") + 1;
    const stayMonths = stayDays / 30;

    const lostRent = await this.lostRentCalculation(row);
    const lostRentPerMonth = lostRent / stayMonths;
    const newMonthlyRent = monthlyRent + lostRentPerMonth;

    console.log({
      dailyrent,
      stayMonths,
      stayDays,
      lostRent,
      lostRentPerMonth,
      newMonthlyRent,
    });
    const stateData = {
      communities: row,
      checkin: this.state.checkin,
      checkout: this.state.checkout,
      monthlyRent: newMonthlyRent.toFixed(2),
    };
    localStorage.setItem("reserveState", JSON.stringify(stateData));
  }

  async handleReserve() {
    $("#sideQuote").addClass("active");
    $(".overlay").addClass("active");
  }

  async handleDateChange(type, date) {
    // If date is valid or a proper date object, proceed
    let formattedDate = moment(date).format("MM/DD/YYYY");

    if (type === "move-in") {
      this.setState({
        moveIn: date,
        checkin: formattedDate,
      });
      if (this.state.moveOut) {
        this.setState({
          moveOut: null,
          checkout: "",
        });
      }
    } else {
      this.setState({
        moveOut: date,
        checkout: formattedDate,
      });
    }
  }
  handleKeyDown = (e) => {
    const invalidChars = [
      ";",
      "<",
      ">",
      "=",
      "{",
      "}",
      "[",
      "]",
      "'",
      '"',
      ",",
      ".",
    ];
    if (invalidChars.includes(e.key)) {
      e.preventDefault();
    }
  };

  handlePaste = (e) => {
    const pasted = e.clipboardData.getData("Text");
    const invalidCharsRegex = /[;<>={}[\]'",.]/;
    if (invalidCharsRegex.test(pasted)) {
      e.preventDefault();
    }
  };

  async handleDropDownSelect(e) {
    this.setState({ size: e.target.value });
  }
  render() {
    let communityData = this.state.communityData;
    let placeholder =
      this.state.selectedAmentiesData.length == 0
        ? "Filters"
        : "Filters ( " + this.state.selectedAmentiesData.length + " )";
    let addclass =
      this.state.selectedAmentiesData.length > 4 ? "ulDropdown" : "";

    return (
      <div className="SAweb_updateUi">
        <Header />
        {this.state.loadingPage && (
          <div className="items">
            <div className="property_loader">
              <Loader />
            </div>
          </div>
        )}
        {!this.state.loadingPage && (
          <section className="SAweb_searchCom my-5">
            <div className="SAweb_container_searchPage instantBooking">
              <div
                className={
                  "row inputSearch align-items-center formQuote " + addclass
                }
              >
                <div className="col-auto">
                  <div className="form-group SAweb_selectDrop min-width popoverView">
                    <div className="requestPlaceHolder" id="showpopup">
                      <input
                        value={this.state.address}
                        id="city-input1"
                        autoComplete="off"
                        type="text"
                        onKeyPress={(e) => this.handleFocus(e)}
                        className="form-control popover_onfocus"
                        name="search"
                        placeholder="Enter Address"
                        onChange={(e) => this.setLocationAddress(e)}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-auto requestPlaceHolder">
                  <div className="input-group datesView">
                    <DatePicker
                      selected={
                        this.state.moveIn ? moment(this.state.moveIn) : null
                      }
                      id="moveIn"
                      onChange={(date) =>
                        this.handleDateChange("move-in", date)
                      }
                      autoComplete="off"
                      dateFormat="MM/DD/YYYY"
                      className="form-control"
                      placeholderText="Check In"
                      minDate={moment().add(4, "days")}
                      onKeyDown={this.handleKeyDown}
                      onPaste={this.handlePaste}
                      // minDate={new Date()}
                    />
                  </div>
                </div>
                <div className="col-auto requestPlaceHolder calendarRightSide">
                  <div className="input-group datesView">
                    <DatePicker
                      selected={
                        this.state.moveOut ? moment(this.state.moveOut) : null
                      }
                      id="moveOut"
                      onChange={(date) =>
                        this.handleDateChange("move-out", date)
                      }
                      dateFormat="MM/DD/YYYY"
                      autoComplete="off"
                      className="form-control"
                      placeholderText="Check Out"
                      minDate={
                        this.state.moveIn
                          ? moment(this.state.moveIn).add(29, "days")
                          : moment().add(5, "days")
                      }
                      onKeyDown={this.handleKeyDown}
                      onPaste={this.handlePaste}
                    />
                  </div>
                </div>
                <div className="col-auto">
                  <div className="input-group">
                    <select
                      className="form-control"
                      onChange={this.handleDropDownSelect}
                      value={this.state.size}
                    >
                      <option value="">All</option>
                      <option value="stu">STU</option>
                      <option value="1x">1X</option>
                      <option value="2x">2X</option>
                      <option value="3x">3X</option>
                    </select>
                  </div>
                </div>

                <div className="col-auto">
                  <div className="form-group">
                    <button
                      className="btn black-btn"
                      type="button"
                      onClick={this.Search}
                    >
                      Search
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className=" SAweb_container_searchPage">
              <div className="searchboxTails mb-4">
                {this.state.loadingStatus ? (
                  <div className="items">
                    <div className="property_loader">
                      <Loader />
                    </div>
                  </div>
                ) : (
                  // !this.state.loadingStatus ?
                  <div className="items">
                    {this.state.communities.length > 0 && (
                      <div className="SAweb_searchResults">
                        <h4>{this.state.communities.length} Results Found</h4>
                      </div>
                    )}

                    {this.state.communities.length == 0 && (
                      <div className="noResultFound ">
                        {/* <img src="/assets/newUI-images/image.png" /> */}
                        {/* <div className="overlay"></div> */}
                        <div className="content">
                          <h3>Oops! We’re All Booked Up</h3>
                          <p>
                            You can try adjusting your dates, or reach out to
                            our team and we’ll help you find a great
                            alternative.
                          </p>
                          <a href="#" onClick={() => this.handleReserve()}>
                            Reach out to our team
                          </a>
                        </div>
                      </div>
                    )}
                    <div
                      id="loadmoredown"
                      className="SAweb_searchResultsItems instaBook"
                    >
                      {this.state.communities.map((row, index) => (
                        <div
                          key={index}
                          onMouseEnter={() =>
                            this.TravelModel.markerPosition(
                              row,
                              index,
                              "locations"
                            )
                          }
                          onMouseLeave={() => this.TravelModel.mouseRemove()}
                        >
                          <div>
                            <div className="pic">
                              <img
                                // onClick={() =>
                                //   this.TravelModel.flyToPlace(
                                //     row,
                                //     index,
                                //     "locations"
                                //   )
                                // }
                                onClick={async (e) => {
                                  e.preventDefault();
                                  await this.calculateMonthlyRent(row);
                                  window.open(
                                    "/instant-booking-details/" +
                                      row.community_name.replace(/\/| /g, "-") +
                                      "-" +
                                      row.masterId,
                                    "_blank"
                                  );
                                }}
                                src={row.banner_image}
                                alt=""
                                width="100%"
                              />
                              <button
                                type="button"
                                className="btn"
                                onClick={() => {
                                  this.handleOpenCarousel(row);
                                }}
                              >
                                {row.interiorimages !== null
                                  ? row.interiorimages.split(",").length + 1
                                  : 0}{" "}
                                Photos{" "}
                              </button>
                            </div>
                            <div className="textView">
                              <div className="d-flex justify-content-between">
                                <h4>
                                  <a
                                    href={
                                      "/instant-booking-details/" +
                                      row.community_name.replace(/\/| /g, "-") +
                                      "-" +
                                      row.masterId
                                    }
                                    target="_blank"
                                    onClick={async (e) => {
                                      e.preventDefault();
                                      await this.calculateMonthlyRent(row);
                                      window.open(
                                        "/instant-booking-details/" +
                                          row.community_name.replace(
                                            /\/| /g,
                                            "-"
                                          ) +
                                          "-" +
                                          row.masterId,
                                        "_blank"
                                      );
                                    }}
                                  >
                                    {row.community_name}
                                  </a>
                                </h4>
                                <h4>ID: {row.masterId}</h4>
                              </div>
                              <h4 style={{ textTransform: "capitalize" }}>
                                {row.address.toLowerCase()},
                                {" " + row.city_name.toLowerCase()},
                                {" " + row.state_name_code}
                              </h4>
                              <div className="listing_amenities">
                                <div className="amenity_first">
                                  <i
                                    className="fa fa-bed"
                                    aria-hidden="true"
                                  ></i>{" "}
                                  <span>{row.bedrooms + " " + "bed"}</span>
                                </div>
                                <div className="amenity">
                                  <i
                                    className="fa fa-bath"
                                    aria-hidden="true"
                                  ></i>
                                  <span>{row.bathrooms + " " + "bath"}</span>
                                </div>
                                {row.sqrfeet != null && (
                                  <div className="amenity">
                                    <i
                                      className="fa fa-arrows"
                                      aria-hidden="true"
                                    ></i>
                                    <span>{row.sqrfeet + " " + "ft²"}</span>
                                  </div>
                                )}
                              </div>

                              {row.mrent != null && (
                                <div className="rateCard">
                                  <span>Rent starting from</span>$
                                  {Number(row.dailyRent).toFixed(2)}{" "}
                                  <sup>/per day</sup>
                                </div>
                              )}

                              <p>
                                {" "}
                                <a
                                  href="javascript:void(0)"
                                  className="btn black-btn"
                                  onClick={async () => {
                                    await this.calculateMonthlyRent(row);
                                    window.open(
                                      "/instant-reserve-book",
                                      "_blank"
                                    );
                                  }}
                                >
                                  Request To Book
                                </a>{" "}
                              </p>
                              <div className="available_date">
                                <span>
                                  Available from:{" "}
                                  {moment(row.availabilityStartDate).format(
                                    "DD MMM YYYY"
                                  )}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                <div className="items">
                  <div className="lc_map">
                    <div
                      className={
                        this.state.mapLoader
                          ? "map-on-loader"
                          : "map-on-loader d-none"
                      }
                    ></div>
                    <div id={"map"} className="map-alignment"></div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}

        <div
          id="smallmodel-Carousel1"
          className=" modal fade SAweb_modalPoup Saweb_MorePhotosPopup "
          role="dialog"
          data-backdrop="static"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered modal-lg-2">
            <div className="modal-content notification-popup borderRadius">
              <div className="modal-header border-0">
                <button
                  type="button"
                  className="btn close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  {" "}
                  <i className="bi bi-x"></i>{" "}
                </button>
              </div>
              <div className="">
                {this.state.communityImages.length > 0 &&
                !this.state.imgloader ? (
                  <div className="">
                    <Spinner fontSize="35px" />
                  </div>
                ) : (
                  <div className="Saweb_MorePhotosSlider">
                    <OwlCarousel
                      className="owl-theme owl-carousel"
                      {...{
                        loop: false,
                        nav: true,
                        dots: true,
                        items: 1,
                        navContainerClass: "owl-buttons",
                        navText: [
                          "<i class='glyphicon glyphicon-menu-left'></i>",
                          "<i class='glyphicon glyphicon-menu-right'></i>",
                        ],
                        responsive: {
                          600: { items: 1, nav: true, loop: false },
                          767: { items: 1, nav: true, loop: false },
                          992: { items: 1, nav: true, loop: false },
                          1199: { items: 1, nav: true, loop: false },
                        },
                      }}
                    >
                      {this.state.communityImages.map((row, index) => {
                        return (
                          <div className="item" key={index}>
                            <img
                              className="img-responsive"
                              src={row.image_name}
                              alt={row}
                            />
                          </div>
                        );
                      })}
                    </OwlCarousel>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <RequestCallback
          selectedcommunityName={this.state.selectedcommunityName}
        />
        <Footer />
        <FullPopup fullpopdata={this.state.fullpopdata} />
      </div>
    );
  }
}
export default NewLocations;
